import { demoGenerators } from "./demo-generators";

export const generatorsQuery = {
  read(_: any, { variables }: { variables?: any }) {
    return demoGenerators;
  },
};
